import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

const resourcePage = {
  department: "Chemistry",
  short: "chemistry",
  programmePath: "/programme/bsh/chemistry",
  description:
    "Access student resources for the Department of Chemistry including syllabus, timetable, academic calendar, lab manuals, question papers, add-on courses, publications, and mentor details.",
  sections: [
    {
      title: "IA Syllabus",
      items: [
        {
          label: "IA Coverage",
          href: "https://drive.google.com/file/d/1nv7jsd4BepFeiYRkGXYq4eZu28jX3ALK/view?usp=drive_link"
        }
      ],
    },
    {
      title: "Timetable",
      items: [
        {
          label: "Timetable",
          href: "https://drive.google.com/file/d/1GqrSfL-KmXG_DYqVNJCeCERdd5_c_GzN/view?usp=drive_link"
        }
      ],
    },
    {
      title: "Academic Calendar",
      items: [
        {
          label: "Calendar of Events",
          href: "https://drive.google.com/file/d/1daygHO3VhNlNC8R3OGDOehTbisW1KMN7/view?usp=drive_link"
        }
      ],
    },
    // {
    //   title: "Lab Manuals",
    //   items: [{ label: "Chemistry Lab Manual", href: "#" }],
    // },
    {
      title: "Question Papers & Solutions",
      items: [
        {
          label: "Chemistry Question Papers and Solutions",
          href: "https://drive.google.com/drive/folders/1nx5rY7MB_lnI79aqgkybOks1SYmig_K2?usp=drive_link"
        }
      ],
    },
    // {
    //   title: "Add-On Subjects",
    //   items: [{ label: "Chemistry Add-On Course Syllabus", href: "#" }],
    // },
    // {
    //   title: "Published Papers & Patents",
    //   items: [{ label: "Chemistry Published Papers / Patents", href: "#" }],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "Mentor List 2025-26",
          href: "https://drive.google.com/file/d/1IfRQUtCD2p59R2Zf945kqLVnx3usvTu1/view?usp=drive_link"
        }
      ],
    },
  ],
};

const ChemistryResources = () => (
  <StudentResourceTemplate resourcePage={resourcePage} />
);

export default ChemistryResources;
